import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useParams, useNavigate } from 'react-router-dom'
import { message } from 'antd'

export default function DeferralQueryPass2() {
  const location = useLocation()
  const { oid } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    document.title = '查询结果'
  }, [oid])

  const handleDownload = () => {
    if (/MicroMessenger/i.test(navigator.userAgent)) {
      navigator.clipboard.writeText(location.state.success_proof_photo).then(() => {
        message.success('下载链接已复制，请在浏览器中打开下载或打印')
      }).catch(err => {
        console.error('复制失败: ', err)
      })
    } else {
      window.open(location.state.success_proof_photo, '_blank')
    }
  }

  const handleReturn = () => {
    navigate('/deferral/query/login/' + oid)
  }

  return (
    <div className='result-page'>
      <div className='application-progress'>
        <div className='application-progress-number'>1</div>
        <div className='application-progress-name'>初审</div>
        <div className='application-progress-line'></div>
        <div className='application-progress-currentNumber'>2</div>
        <div className='application-progress-name'>复审</div>
      </div>

      <div className='result-icon'>
        <img src="/images/chenggong.png" alt="" />
      </div>
      <div className='result-title'>复审通过</div>
      <div className='result-description'>
        您的申请已通过审核，请自行下载证明文件并留存。
      </div>
      <div className='result-button-primary' onClick={handleDownload}>《保留入学资格证明》</div>
      <div className='result-button-secondary' onClick={handleReturn}>返回</div>
    </div>
  )
}
